//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import context from "context/context";
import { useHistory } from "react-router-dom";
import * as moment from "moment";


// custom pages
import Table from "components/Table/Table";
import response from "apis/Response/response"
import { styles } from "./styles";
import Loader from "components/Loader/Loader";
import VisibilityIcon from "@material-ui/icons/Visibility";
import HistoryTable from "components/Table/History/HistoryTable";

// material-ui
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import InputAdornment from '@material-ui/core/InputAdornment';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import searchIcon from 'assets/img/Search_Icon.png';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import useDebounce from 'helpers/useDebounce';






const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      marginTop: 0,
    },
  },
})(TextField);

export default function Response(props) {
  const { state, dispatch } = useContext(context);
  const { getResponse,searchAPI } = response();

  const history = useHistory();
  const classes = styles();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [res, setRes] = useState(false);
  
  const [isActive, setIsActive] = useState(true);
  const [searchValue, setSearchValue] = useState('');

  let searchBounceValues = useDebounce(() => {
    return searchValue === '' ? '' : searchValue;
});
// const { clearSearch } = states;
  // For bread-crumbs
  useEffect(() => {
    dispatch({ type: "SET_PATHNAME", payload: ["HOME", "ADMIN", "RESPONSE"] });
  }, []);

  const [states, setstates] = useState({ historyLoader: false,clearSearch: false });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };
  useEffect(() => {
    if (!states?.clearSearch) {
        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch();
        }
        else {
          handleGet();
        }
    }
    else {
        setStates({ clearSearch: false });
    }
}, [searchBounceValues, offset,isActive]);

  // handling api calls
  useEffect(() => {
    handleGet();
  }, [offset, isActive]);

  // get api func
  const handleGet = async () => {
    try {
      dispatch({ type: 'SET_LOADING', payload: true })
      let values;
      values = {
        offset: (offset - 1) * 20,
        limit: 20
      };
      let res = await getResponse(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setRes(true);
      }
      dispatch({ type: 'SET_LOADING', payload: false })
    }
    catch (e) {
      console.log({ e });
    }
  };
  async function handleSearch() {
    try {
 
      dispatch({ type: 'SET_LOADING', payload: true })

        let values;
        values = {
            search: searchValue,
            offset: (offset - 1) * 10,
            limit: 10,
        };            
        // setResponse({ ...response, filter: false });
        dispatch({ type: "SET_LOADING", payload: true });
        let res = await searchAPI(values);
        if (res) {
          setData(res.data);
          setCount(res.count);
          setRes(true);
            dispatch({ type: 'SET_LOADING', payload: false });
        }
    } catch (e) {
        console.log({ e });
    }
}
const blockInvalidChar = e => ['.', '-','+','ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault();

  return (
    <React.Fragment>
      <Grid container className={classes.root}>
        <Grid item xs={12} sm={12} lg={12} style={{ position: 'relative' }}>
        {/* <div style={{ flex: 0.99 }}> */}
        <CssTextField
              placeholder={'Search for Keyword'}
              type={"text"}
              variant="outlined"
              onKeyDown={blockInvalidChar}
              className={classes.searchInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchValue.length > 0 ? (
                      <CloseOutlinedIcon
                        className={classes.searchInputIcon}
                        onClick={() => {
                          setSearchValue("");
                          setOffset(1);
                          handleGet();
                        }}
                      />
                    ) : (
                      <img
                        src={searchIcon}
                        alt=""
                        width="20px"
                        className={classes.searchInputIcon}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setOffset(1);
                if (e.target.value.length == 0) {
                  handleGet();
                }
              }}
              onClick={() => {
                setOffset(offset);
              }}
            />                   
                {/* </div> */}
          <Button
            className={`${classes.createBtn} dash-1-filter-btn`}
            onClick={() => {
              history.push("/dashboard/create-response");
            }}
          >
            {'Create'}
          </Button>
        </Grid>
      </Grid>
      <Loader loading={state.loading} top="15%">
        <Grid className={classes.tableDownInResponsive}>
          <Grid item xs={12} sm={12} lg={12}>
            {res ? (
              <Table
                headings={[
                  "S.No",
                  "Status Code",
                  "Type",
                  "Keyword",
                  "Message",
                  "Operation"
                ]}
                data={
                  data &&
                  data.length > 0 &&
                  data.map((d, i) => [
                    ((offset - 1) * 20) + (i + 1),
                    d?.status_code,
                    d?.type,
                    d?.keyword,
                    d?.message,
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/dashboard/view-response", { data: d });
                      }}
                    >
                      <VisibilityIcon />
                    </div>
                  ])
                }
                offset={offset}
                count={
                  (count / 20) % 1 == 0
                    ? Math.floor(count / 20)
                    : Math.floor(count / 20 + 1)
                }
                handlePagination={handlePagination}
              />
            ) : (
              <Loader Loading={true} top={"15%"} />
            )}
          </Grid>
        </Grid>
      </Loader>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog ? true : false}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {'History'}{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}` : "",
                  `${d?.["User.email"] ? d?.["User.email"] : d?.altered_by ? d?.altered_by.charAt(0).toUpperCase() + d?.altered_by.slice(1).toLowerCase() : "-"}`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
    </React.Fragment>
  );
}
